import React from "react";
import {
  ErrorMessage,
  InfoMessage,
  StringValidations,
  SuccessMessage,
} from "../../Utils/Utils";
import { useState, useEffect } from "react";
import {
  Upload,
  Button,
  Spin,
  Input,
  Table,
  Typography,
  Popconfirm,
  message,
  Form,
} from "antd";
import axios from "axios";
import * as XLSX from "xlsx";
import {
  DeleteOutlined,
  LoadingOutlined,
  PlusOutlined,
  ReloadOutlined,
  UploadOutlined,
  FilterOutlined,
  FullscreenOutlined,
  SearchOutlined,
  DownloadOutlined,
  EditOutlined,
  CloseOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import Cookies from "js-cookie";
// import "../NewHiresReHires/NewHireReHires.css";
import "../../GlobalCss/SPF/NewHireReHires.css";
import {
  AddNewHireReHireEmployee,
  DeleteNewHireReHireEmployee,
  UpdateNewHireReHireEmployee,
} from "../../Repository/NewHireReHireRepository";
import ExcelJS from "exceljs";
import FileSaver from "file-saver";

const { Text } = Typography;
const NewHiresReHires = () => {
  const jwtToken = Cookies.get("jwt_token");
  const userLogin = Cookies.get("UserLogin");
  const [AdjUploadFlag, setAdjUploadFlag] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [manualLoadingFileName, setManualLoadingFileName] = useState("");
  const [uploadSpinLoader, setUploadSpinLoader] = useState(false);
  const [data, setData] = useState([]);
  const [oldData, setOldData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [SearchGrid, setSearchGrid] = useState("");
  const [NewRecordKey, setNewRecordKey] = useState(null);
  const [spin, setSpin] = useState(false);
  const [CurrentEditingKey, setCurrentEditingKey] = useState("");
  const [form] = Form.useForm();
  const isEditing = (record) => record.employeeID === CurrentEditingKey;
  const [EditingRecord, setEditingRecord] = useState(null);
  const [AddNewDisable, setAddNewDisable] = useState(false);
  const IsRecordInEditingState = (employeeID) => employeeID === EditingRecord;

  const GetTableData = () => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}Newhire/Getfiledata`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${jwtToken}`,
        },
      })
      .then((response) => {
        setData(response.data.result);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    GetTableData();
  }, []);

  const handleSaveNewHireReHire = async () => {
    if (form.isFieldsTouched()) {
      const UpdatedData = form.getFieldsValue();
      if (["M", "F", ""].includes(UpdatedData?.sex.trim())) {
        const Response = await UpdateNewHireReHireEmployee(UpdatedData);
        Response.isSuccess === true
          ? SuccessMessage(Response.message)
          : ErrorMessage(Response.message);
        GetTableData();
        setCurrentEditingKey("");
        setAddNewDisable(false);
      }
    } else {
      InfoMessage("No changes to Save");
    }
  };

  const handleDeleteNewHireReHire = async (EmployeeId) => {
    const Response = await DeleteNewHireReHireEmployee(EmployeeId);
    Response.isSuccess === true
      ? SuccessMessage(Response.message)
      : ErrorMessage(Response.message);
    GetTableData();
    setAddNewDisable(false);
    setCurrentEditingKey("");
  };

  const handleAddNewHireReHire = async () => {
    setAddNewDisable(true);
    const NewRecord = form.getFieldsValue();
    if (NewRecord.employeeID === "tempId") {
      InfoMessage("Please provide a proper Employee ID");

      return;
    }
    const Response = await AddNewHireReHireEmployee(NewRecord);
    Response.isSuccess === true
      ? SuccessMessage(Response.message)
      : ErrorMessage(Response.message);
    GetTableData();
    setCurrentEditingKey("");
    setAddNewDisable(false);
  };

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    record,
    index,
    children,
    ...restProps
  }) => {
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: dataIndex === "sex",
                message: `Please enter valid gender!`,
                validator(rule, value) {
                  return new Promise((resolve, reject) => {
                    if (dataIndex === "sex") {
                      if (["M", "F", ""].includes(value.trim())) {
                        return resolve();
                      } else {
                        return reject();
                      }
                    } else {
                      return resolve();
                    }
                  });
                },
              },
            ]}
          >
            <Input />
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  //Filter Feature for Grid Layout
  const filterProps = () => ({
    filteredValue: [SearchGrid],
    onFilter: (value, record) => {
      return (
        String(record.employeeID)
          .toLowerCase()
          .includes(String(value).toLowerCase()) ||
        String(record.firstName)
          .toLowerCase()
          .includes(String(value).toLowerCase()) ||
        String(record.companyID).toLowerCase().includes(value.toLowerCase())
      );
    },
  });

  const SearchEmployee = (value) => {
    // console.log(value);
    setSearchGrid(value);
  };

  const columns = [
    {
      title: "Company Id",
      dataIndex: "companyID",
      editable: true,
      width: 110,
      fixed: "left",
      ...filterProps(),
    },
    {
      title: "Employee ID",
      dataIndex: "employeeID",
      editable: true,
      width: 110,
      fixed: "left",
    },
    {
      title: "Employee Type",
      dataIndex: "employeeType",
      editable: true,
      width: 120,
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      editable: true,
      width: 150,
    },
    {
      title: "Middle Name",
      dataIndex: "middleName",
      editable: true,
      width: 150,
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      editable: true,
      width: 150,
    },
    {
      title: "Preferred Name",
      dataIndex: "preferredName",
      editable: true,
      width: 120,
    },
    {
      title: "IC Company Name",
      dataIndex: "icCompanyName",
      editable: true,
      width: 140,
    },
    {
      title: "SSN",
      dataIndex: "ssn",
      editable: true,
      width: 140,
      render: (text, record) => (
        <EditableCell
          dataIndex={`ssn_${record.ssn}`}
          editing={IsRecordInEditingState(record.ssn)}
        >
          {IsRecordInEditingState(record.ssn)
            ? text || ""
            : text
            ? "*******"
            : ""}
        </EditableCell>
      ),
    },

    {
      title: "Federal ID Number",
      dataIndex: "federalIDNumber",
      editable: true,
      width: 140,
    },
    {
      title: "Birth Date",
      dataIndex: "birthDate",
      editable: true,
      width: 150,
    },
    {
      title: "Clock ID",
      dataIndex: "clockID",
      editable: true,
      width: 100,
    },
    {
      title: "Sex",
      dataIndex: "sex",
      editable: true,
      width: 100,
    },
    {
      title: "Ethnic Origin",
      dataIndex: "ethnicOrigin",
      editable: true,
      width: 110,
    },
    {
      title: "Address 1",
      dataIndex: "address1",
      editable: true,
      width: 170,
    },
    {
      title: "Address 2",
      dataIndex: "address2",
      editable: true,
      width: 150,
    },
    {
      title: "PO Box Number",
      dataIndex: "poBoxNumber",
      editable: true,
      width: 130,
    },
    {
      title: "City",
      dataIndex: "city",
      editable: true,
      width: 120,
    },
    {
      title: "State/Province",
      dataIndex: "stateProvince",
      editable: true,
      width: 130,
    },
    {
      title: "Zip/Postal Code",
      dataIndex: "zipPostalCode",
      editable: true,
      width: 130,
    },
    {
      title: "Country",
      dataIndex: "country",
      editable: true,
      width: 100,
    },

    {
      title: "Telephone",
      dataIndex: "telephone",
      editable: true,
      width: 170,
      render: (text, record) => (
        <EditableCell
          dataIndex={`telephone_${record.telephone}`}
          editing={IsRecordInEditingState(record.telephone)}
        >
          {IsRecordInEditingState(record.telephone)
            ? text || ""
            : text
            ? "*******"
            : ""}
        </EditableCell>
      ),
    },

    {
      title: "Cell Phone",
      dataIndex: "cellPhone",
      editable: true,
      width: 170,
      render: (text, record) => (
        <EditableCell
          dataIndex={`cellPhone_${record.cellPhone}`}
          editing={IsRecordInEditingState(record.cellPhone)}
        >
          {IsRecordInEditingState(record.cellPhone)
            ? text || ""
            : text
            ? "*******"
            : ""}
        </EditableCell>
      ),
    },
    {
      title: "Work Phone",
      dataIndex: "workPhone",
      editable: true,
      width: 170,
      render: (text, record) => (
        <EditableCell
          dataIndex={`workPhone_${record.workPhone}`}
          editing={IsRecordInEditingState(record.workPhone)}
        >
          {IsRecordInEditingState(record.workPhone)
            ? text || ""
            : text
            ? "*******"
            : ""}
        </EditableCell>
      ),
    },

    {
      title: "Work Phone Ext",
      dataIndex: "workPhoneExt",
      editable: true,
      width: 120,
    },
    {
      title: "Full/Part Time",
      dataIndex: "fullPartTime",
      editable: true,
      width: 120,
    },
    {
      title: "Eligible for Retirement Plan",
      dataIndex: "eligibleForRetirementPlan",
      editable: true,
      width: 200,
    },
    {
      title: "Organization Unit",
      dataIndex: "organizationUnit",
      editable: true,
      width: 150,
    },
    {
      title: "Business Location Name",
      dataIndex: "businessLocationName",
      editable: true,
      width: 180,
    },
    {
      title: "Position",
      dataIndex: "position",
      editable: true,
      width: 220,
    },
    {
      title: "EEO Job Category",
      dataIndex: "eeoJobCategory",
      editable: true,
      width: 150,
    },
    {
      title: "Work State",
      dataIndex: "workState",
      editable: true,
      width: 120,
    },
    {
      title: "Officer Type",
      dataIndex: "officerType",
      editable: true,
      width: 120,
    },
    {
      title: "Class Code",
      dataIndex: "classCode",
      editable: true,
      width: 120,
    },
    {
      title: "Class Code Suffix",
      dataIndex: "classCodeSuffix",
      editable: true,
      width: 130,
    },
    {
      title: "Waive Code",
      dataIndex: "waiveCode",
      editable: true,
      width: 120,
    },
    {
      title: "Employee Status",
      dataIndex: "employeeStatus",
      editable: true,
      width: 130,
    },
    {
      title: "Reason",
      dataIndex: "reason",
      editable: true,
      width: 100,
    },
    {
      title: "Reason Description",
      dataIndex: "reasonDescription",
      editable: true,
      width: 150,
    },
    {
      title: "Keep DD Active",
      dataIndex: "keepDDActive",
      editable: true,
      width: 150,
    },
    {
      title: "Deactivate Date",
      dataIndex: "deactiveDate",
      editable: true,
      width: 150,
    },
    {
      title: "Benefits Termination Reason",
      dataIndex: "benefitsTerminationReason",
      editable: true,
      width: 220,
    },
    {
      title: "Status Date",
      dataIndex: "statusDate",
      editable: true,
      width: 130,
    },
    {
      title: "Supervisor",
      dataIndex: "supervisor",
      editable: true,
      width: 100,
    },
    {
      title: "Pay Rate 1",
      dataIndex: "payRate1",
      editable: true,
      width: 100,
    },
    {
      title: "Pay Rate Amount 1",
      dataIndex: "payRateAmount1",
      editable: true,
      width: 150,
    },
    {
      title: "Pay Rate 1 Org Unit",
      dataIndex: "payRate1OrgUnit",
      editable: true,
      width: 150,
    },
    {
      title: "Pay Rate #",
      dataIndex: "payRate",
      editable: true,
      width: 110,
    },
    {
      title: "Pay Rate Amount #",
      dataIndex: "payRateAmount",
      editable: true,
      width: 150,
    },
    {
      title: "Pay Rate # Org Unit",
      dataIndex: "payRateOrgUnit",
      editable: true,
      width: 150,
    },
    {
      title: "Pay Rate Default",
      dataIndex: "payRateDefault",
      editable: true,
      width: 150,
    },
    {
      title: "Pay Frequency",
      dataIndex: "payFrequency",
      editable: true,
      width: 110,
    },
    {
      title: "Benefits Pay Frequency",
      dataIndex: "benefitsPayFrequency",
      editable: true,
      width: 170,
    },
    {
      title: "Standard Pay Hours",
      dataIndex: "standardPayHours",
      editable: true,
      width: 150,
    },
    {
      title: "Standard OT Hours",
      dataIndex: "standardOTHours",
      editable: true,
      width: 150,
    },
    {
      title: "Standard Hours #",
      dataIndex: "standardHours",
      editable: true,
      width: 130,
    },
    {
      title: "Standard OT Hours #",
      dataIndex: "standardOTHoursNum",
      editable: true,
      width: 150,
    },
    {
      title: "Overtime Exempt",
      dataIndex: "overtimeExempt",
      editable: true,
      width: 130,
    },
    {
      title: "Federal Tax Residency",
      dataIndex: "federalTaxResidency",
      editable: true,
      width: 170,
    },
    {
      title: "Federal Taxability Status",
      dataIndex: "federalTaxabilityStatus",
      editable: true,
      width: 180,
    },
    {
      title: "Federal Filing Status",
      dataIndex: "federalFilingStatus",
      editable: true,
      width: 170,
    },
    {
      title: "Federal Allowances",
      dataIndex: "federalAllowances",
      editable: true,
      width: 150,
    },
    {
      title: "Multiple Jobs",
      dataIndex: "multipleJobs",
      editable: true,
      width: 130,
    },
    {
      title: "Dependents Amount",
      dataIndex: "dependentsAmount",
      editable: true,
      width: 150,
    },
    {
      title: "Deductions Amount",
      dataIndex: "deductionsAmount",
      editable: true,
      width: 150,
    },
    {
      title: "Other Income",
      dataIndex: "otherIncome",
      editable: true,
      width: 130,
    },
    {
      title: "Federal Additonal Tax Amount",
      dataIndex: "federalAdditionalTaxAmount",
      editable: true,
      width: 220,
    },
    {
      title: "Federal Additional Tax Percentage",
      dataIndex: "federalAdditionalTaxPercentage",
      editable: true,
      width: 240,
    },
    {
      title: "Federal Additional Tax Percentage",
      dataIndex: "federalOverrideTaxAmount",
      editable: true,
      width: 240,
    },
    {
      title: "Federal Override Tax Percentage",
      dataIndex: "federalOverrideTaxPercentage",
      editable: true,
      width: 240,
    },
    {
      title: "EE Sequence",
      dataIndex: "eeSequence",
      editable: true,
      width: 120,
    },
    {
      title: "State Income Tax",
      dataIndex: "stateIncomeTax",
      editable: true,
      width: 140,
    },
    {
      title: "State Tax Residency",
      dataIndex: "stateTaxResidency",
      editable: true,
      width: 150,
    },
    {
      title: "State Percent Worked",
      dataIndex: "statePercentWorked",
      editable: true,
      width: 160,
    },
    {
      title: "State Taxibility Status",
      dataIndex: "stateTaxabilityStatus",
      editable: true,
      width: 160,
    },
    {
      title: "State Unemployment",
      dataIndex: "stateUnemployment",
      editable: true,
      width: 160,
    },
    {
      title: "Worksite Code",
      dataIndex: "worksiteCode",
      editable: true,
      width: 140,
    },
    {
      title: "State Disability",
      dataIndex: "stateDisability",
      editable: true,
      width: 140,
    },
    {
      title: "State Filing Status",
      dataIndex: "stateFilingStatus",
      editable: true,
      width: 140,
    },

    {
      title: "State Allowance Name 1",
      dataIndex: "stateAllowanceName1",
      editable: true,
      width: 180,
    },
    {
      title: "State Allowance Number 1",
      dataIndex: "stateAllowanceNumber1",
      editable: true,
      width: 190,
    },
    {
      title: "State Allowance Amount 1",
      dataIndex: "stateAllowanceAmount1",
      editable: true,
      width: 190,
    },
    {
      title: "State Allowance Name 2",
      dataIndex: "stateAllowanceName2",
      editable: true,
      width: 190,
    },
    {
      title: "State Allowance Number 2",
      dataIndex: "stateAllowanceNumber2",
      editable: true,
      width: 190,
    },
    {
      title: "State Allowance Amount 2",
      dataIndex: "stateAllowanceAmount2",
      editable: true,
      width: 190,
    },
    {
      title: "State Allowance Name 3",
      dataIndex: "stateAllowanceName3",
      editable: true,
      width: 190,
    },
    {
      title: "State Allowance Number 3",
      dataIndex: "stateAllowanceNumber3",
      editable: true,
      width: 190,
    },
    {
      title: "State Allowance Amount 3",
      dataIndex: "stateAllowanceAmount3",
      editable: true,
      width: 190,
    },

    {
      title: "State Additional Tax Amount",
      dataIndex: "stateAdditionalTaxAmount",
      editable: true,
      width: 220,
    },
    {
      title: "State Additional Tax Percentage",
      dataIndex: "stateAdditionalTaxPercentage",
      editable: true,
      width: 240,
    },
    {
      title: "State Override Tax Amount",
      dataIndex: "stateOverrideTaxAmount",
      editable: true,
      width: 190,
    },
    {
      title: "State Override Tax Percentage",
      dataIndex: "stateOverrideTaxPercentage",
      editable: true,
      width: 210,
    },
    {
      title: "Reduced Withholding Amount",
      dataIndex: "reducedWithholdingAmount",
      editable: true,
      width: 210,
    },
    {
      title: "State Withholding %",
      dataIndex: "stateWithholdingPercentage",
      editable: true,
      width: 180,
    },
    {
      title: "Dependent Health Insurance Benefits Indicator",
      dataIndex: "dependentHealthInsuranceBenefitsIndicator",
      editable: true,
      width: 320,
    },
    {
      title: "Date Dependent Health Ins Benefits are Available",
      dataIndex: "dateDependentHealthInsBenefitsAvailable",
      editable: true,
      width: 320,
    },
    {
      title: "Employee Health Insurance Benefits Indicator",
      dataIndex: "employeeHealthInsuranceBenefitsIndicator",
      editable: true,
      width: 320,
    },
    {
      title: "Date Employee Health Ins Benefits are Available",
      dataIndex: "dateEmployeeHealthInsBenefitsAvailable",
      editable: true,
      width: 350,
    },
    {
      title: "County",
      dataIndex: "county",
      editable: true,
      width: 100,
    },
    {
      title: "Family Owned Business Owner Indicator",
      dataIndex: "familyOwnedBusinessOwnerIndicator",
      editable: true,
      width: 270,
    },
    {
      title: "Seasonal Indicator",
      dataIndex: "seasonalIndicator",
      editable: true,
      width: 150,
    },
    {
      title: "SOC",
      dataIndex: "soc",
      editable: true,
      width: 100,
    },
    {
      title: "SUI County",
      dataIndex: "suiCounty",
      editable: true,
      width: 100,
    },

    {
      title: "State Jurisdiction 1",
      dataIndex: "stateJurisdiction1",
      editable: true,
      width: 170,
    },
    {
      title: "Local Regulation Name 1",
      dataIndex: "localRegulationName1",
      editable: true,
      width: 180,
    },
    {
      title: "Local Tax Residency 1",
      dataIndex: "localTaxResidency1",
      editable: true,
      width: 170,
    },
    {
      title: "PA Live/Work Status 1",
      dataIndex: "paLiveWorkStatus1",
      editable: true,
      width: 170,
    },
    {
      title: "Local Taxability Status 1",
      dataIndex: "localTaxabilityStatus1",
      editable: true,
      width: 170,
    },
    {
      title: "Local Filing Status 1",
      dataIndex: "localFilingStatus1",
      editable: true,
      width: 170,
    },
    {
      title: "Local Allowance Name 1",
      dataIndex: "localAllowanceName1",
      editable: true,
      width: 170,
    },
    {
      title: "Local Allowance Number 1",
      dataIndex: "localAllowanceNumber1",
      editable: true,
      width: 190,
    },
    {
      title: "% of Earnings Taxed 1",
      dataIndex: "percentOfEarningsTaxed1",
      editable: true,
      width: 190,
    },
    {
      title: "Ohio Local Residence Tax Rate 1",
      dataIndex: "ohioLocalResidenceTaxRate1",
      editable: true,
      width: 220,
    },
    {
      title: "Local Additional Tax Amount 1",
      dataIndex: "localAdditionalTaxAmount1",
      editable: true,
      width: 220,
    },
    {
      title: "Local Additional Tax Percent 1",
      dataIndex: "localAdditionalTaxPercentage1",
      editable: true,
      width: 220,
    },
    {
      title: "Local Override Tax Amount 1",
      dataIndex: "localOverrideTaxAmount1",
      editable: true,
      width: 220,
    },
    {
      title: "Local Override Tax Percent 1",
      dataIndex: "localOverrideTaxPercentage1",
      editable: true,
      width: 220,
    },
    {
      title: "Employee Waiver Indicator 1",
      dataIndex: "employeeWaiverIndicator1",
      editable: true,
      width: 220,
    },
    {
      title: "State Jurisdiction2",
      dataIndex: "stateJurisdiction2",
      editable: true,
      width: 190,
    },
    {
      title: "Local Regulation Name 2",
      dataIndex: "localRegulationName2",
      editable: true,
      width: 190,
    },
    {
      title: "Local Tax Residency 2",
      dataIndex: "localTaxResidency2",
      editable: true,
      width: 190,
    },
    {
      title: "PA Live/Work Status 2",
      dataIndex: "paLiveWorkStatus2",
      editable: true,
      width: 190,
    },
    {
      title: "Local Taxability Status 2",
      dataIndex: "localTaxabilityStatus2",
      editable: true,
      width: 190,
    },
    {
      title: "Local Filing Status 2",
      dataIndex: "localFilingStatus2",
      editable: true,
      width: 190,
    },
    {
      title: "Local Allowance Name 2",
      dataIndex: "localAllowanceName2",
      editable: true,
      width: 190,
    },
    {
      title: "Local Allowance Number 2",
      dataIndex: "localAllowanceNumber2",
      editable: true,
      width: 190,
    },

    {
      title: "% of Earnings Taxed 2",
      dataIndex: "percentOfEarningsTaxed2",
      editable: true,
      width: 190,
    },
    {
      title: "Ohio Local Residence Tax Rate 2",
      dataIndex: "ohioLocalResidenceTaxRate2",
      editable: true,
      width: 220,
    },
    {
      title: "Local Additional Tax Amount 2",
      dataIndex: "localAdditionalTaxAmount2",
      editable: true,
      width: 220,
    },
    {
      title: "Local Additional Tax Percent 2",
      dataIndex: "localAdditionalTaxPercentage2",
      editable: true,
      width: 220,
    },
    {
      title: "Local Override Tax Amount 2",
      dataIndex: "localOverrideTaxAmount2",
      editable: true,
      width: 220,
    },
    {
      title: "Local Override Tax Percent 2",
      dataIndex: "localOverrideTaxPercentage2",
      editable: true,
      width: 220,
    },
    {
      title: "Employee Waiver Indicator 2",
      dataIndex: "employeeWaiverIndicator2",
      editable: true,
      width: 200,
    },
    {
      title: "State Jurisdiction 3",
      dataIndex: "stateJurisdiction3",
      editable: true,
      width: 170,
    },
    {
      title: "Local Regulation Name 3",
      dataIndex: "localRegulationName3",
      editable: true,
      width: 190,
    },
    {
      title: "Local Tax Residency 3",
      dataIndex: "localTaxResidency3",
      editable: true,
      width: 190,
    },
    {
      title: "PA Live/Work Status 3",
      dataIndex: "paLiveWorkStatus3",
      editable: true,
      width: 190,
    },
    {
      title: "Local Taxability Status 3",
      dataIndex: "localTaxabilityStatus3",
      editable: true,
      width: 190,
    },
    {
      title: "Local Filing Status 3",
      dataIndex: "localFilingStatus3",
      editable: true,
      width: 190,
    },
    {
      title: "Local Allowance Name 3",
      dataIndex: "localAllowanceName3",
      editable: true,
      width: 190,
    },
    {
      title: "Local Allowance Number 3",
      dataIndex: "localAllowanceNumber3",
      editable: true,
      width: 190,
    },
    {
      title: "% of Earnings Taxed 3",
      dataIndex: "percentOfEarningsTaxed3",
      editable: true,
      width: 190,
    },
    {
      title: "Ohio Local Residence Tax Rate 3",
      dataIndex: "ohioLocalResidenceTaxRate3",
      editable: true,
      width: 220,
    },
    {
      title: "Local Additional Tax Amount 3",
      dataIndex: "localAdditionalTaxAmount3",
      editable: true,
      width: 220,
    },
    {
      title: "Local Additional Tax Percent 3",
      dataIndex: "localAdditionalTaxPercentage3",
      editable: true,
      width: 220,
    },
    {
      title: "Local Override Tax Amount 3",
      dataIndex: "localOverrideTaxAmount3",
      editable: true,
      width: 220,
    },
    {
      title: "Local Override Tax Percent 3",
      dataIndex: "localOverrideTaxPercentage3",
      editable: true,
      width: 220,
    },
    {
      title: "Employee Waiver Indicator 3",
      dataIndex: "employeeWaiverIndicator3",
      editable: true,
      width: 220,
    },
    {
      title: "Job Number",
      dataIndex: "jobNumber",
      editable: true,
      width: 120,
    },
    {
      title: "Labor Assignment",
      dataIndex: "laborAssignment",
      editable: true,
      width: 140,
    },
    {
      title: "Home Email",
      dataIndex: "homeEmail",
      editable: true,
      width: 220,
      render: (text, record) => (
        <EditableCell
          dataIndex={`homeEmail_${record.homeEmail}`}
          editing={IsRecordInEditingState(record.homeEmail)}
        >
          {IsRecordInEditingState(record.homeEmail)
            ? text || ""
            : text
            ? "*******"
            : ""}
        </EditableCell>
      ),
    },
    {
      title: "Work Email",
      dataIndex: "workEmail",
      editable: true,
      width: 250,
      render: (text, record) => (
        <EditableCell
          dataIndex={`workEmail_${record.workEmail}`}
          editing={IsRecordInEditingState(record.workEmail)}
        >
          {IsRecordInEditingState(record.workEmail)
            ? text || ""
            : text
            ? "*******"
            : ""}
        </EditableCell>
      ),
    },

    {
      title: "Hired Date",
      dataIndex: "hiredDate",
      editable: true,
      width: 140,
    },
    {
      title: "Benefits Eligibility Indicator",
      dataIndex: "benefitsEligibilityIndicator",
      editable: true,
      width: 200,
    },
    {
      title: "Benefits Override Date",
      dataIndex: "benefitsOverrideDate",
      editable: true,
      width: 190,
    },
    {
      title: "Benefits Custom Field Name 1",
      dataIndex: "benefitsCustomFieldName1",
      editable: true,
      width: 200,
    },
    {
      title: "Benefits Custom Field Value 1",
      dataIndex: "benefitsCustomFieldValue1",
      editable: true,
      width: 210,
    },
    {
      title: "Benefits Custom Field Name 2",
      dataIndex: "benefitsCustomFieldName2",
      editable: true,
      width: 210,
    },
    {
      title: "Benefits Custom Field Value 2",
      dataIndex: "benefitsCustomFieldValue2",
      editable: true,
      width: 210,
    },
    {
      title: "Benefits Custom Field Name 3",
      dataIndex: "benefitsCustomFieldName3",
      editable: true,
      width: 210,
    },
    {
      title: "Benefits Custom Field Value 3",
      dataIndex: "benefitsCustomFieldValue3",
      editable: true,
      width: 210,
    },
    {
      title: "Benefits Custom Field Name 4",
      dataIndex: "benefitsCustomFieldName4",
      editable: true,
      width: 210,
    },
    {
      title: "Benefits Custom Field Value 4",
      dataIndex: "benefitsCustomFieldValue4",
      editable: true,
      width: 210,
    },
    {
      title: "Benefits Custom Field Name 5",
      dataIndex: "benefitsCustomFieldName5",
      editable: true,
      width: 210,
    },
    {
      title: "Benefits Custom Field Value 5",
      dataIndex: "benefitsCustomFieldValue5",
      editable: true,
      width: 210,
    },
    {
      title: "Benefits Custom Field Name 6",
      dataIndex: "benefitsCustomFieldName6",
      editable: true,
      width: 210,
    },
    {
      title: "Benefits Custom Field Value 6",
      dataIndex: "benefitsCustomFieldValue6",
      editable: true,
      width: 210,
    },
    {
      title: "Benefits Custom Field Name 7",
      dataIndex: "benefitsCustomFieldName7",
      editable: true,
      width: 210,
    },
    {
      title: "Benefits Custom Field Value 7",
      dataIndex: "benefitsCustomFieldValue7",
      editable: true,
      width: 210,
    },
    {
      title: "Insurance Standard Hours Same as Standard Hours",
      dataIndex: "insuranceStandardHoursSameAsStandardHours",
      editable: true,
      width: 340,
    },
    {
      title: "Insurance Standard Hours",
      dataIndex: "insuranceStandardHours",
      editable: true,
      width: 190,
    },
    {
      title: "Insurance Annual Salary Override",
      dataIndex: "insuranceAnnualSalaryOverride",
      editable: true,
      width: 240,
    },
    {
      title: "Insurance Annual Salary",
      dataIndex: "insuranceAnnualSalary",
      editable: true,
      width: 190,
    },
    {
      title: "Action",
      key: "edit",
      fixed: "right",
      width: 60,
      render: (_, record) => {
        return (
          <>
            {isEditing(record) ? (
              // When isEditing is true
              <div>
                {record.employeeID === NewRecordKey ? (
                  // When NewRecordKey is "tempId"
                  <PlusOutlined onClick={() => handleAddNewHireReHire()} />
                ) : (
                  <CheckOutlined
                    onClick={() => handleSaveNewHireReHire()}
                    style={{ marginRight: "5px", color: "green" }}
                  />
                )}

                <CloseOutlined
                  style={{ color: "red" }}
                  onClick={() => {
                    if (record.employeeID === NewRecordKey) {
                      setData(oldData);
                      setCurrentEditingKey("");
                      setNewRecordKey("");
                      setAddNewDisable(false);
                    } else {
                      setCurrentEditingKey("");
                      setNewRecordKey("");
                    }
                  }}
                />
              </div>
            ) : (
              // When isEditing is false and NewRecordKey is not "tempId"
              <div>
                <Typography.Link
                  disabled={CurrentEditingKey!==""}
                  onClick={() => {
                    form.setFieldsValue({ ...record });
                    setCurrentEditingKey(record.employeeID);
                  }}
                >
                  <EditOutlined style={{ marginRight: "5px" }} />
                </Typography.Link>
                <Popconfirm
                  title="Are you sure want to delete?"
                  onConfirm={() => handleDeleteNewHireReHire(record.employeeID)}
                  okText="Yes"
                  cancelText="No"
                >
                  <DeleteOutlined style={{ color: "red" }} />
                </Popconfirm>
              </div>
            )}
          </>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const UploadManualAdjustment = async (options) => {
    // Set a flag to indicate that an upload is in progress
    setAdjUploadFlag(true);

    // Accessing file from upload action
    const { file, onSuccess, onError } = options;

    // Check if the selected file is an Excel file (xls or xlsx)
    if (
      file &&
      file.type !== "application/vnd.ms-excel" &&
      file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      message.error("Please upload only .xls or .xlsx files.");
      setAdjUploadFlag(false);
      return;
    }

    //Creating FormData Format to make a HTTP request

    const updatedFile = { file, status: "uploading" };
    const formData = new FormData();
    formData.append("file", file);

    // Read the uploaded Excel file data
    const reader = new FileReader();

    // Wrap the reader.onload callback in an async function
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Assuming the first sheet in the Excel file contains the data with headers in the first row
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert the worksheet to an array of objects (header: value)
      const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      try {
        // Send the file using axios post request
        setManualLoadingFileName(file.name);
        const url = `${process.env.REACT_APP_BASE_URL}Newhire/ManualUpload`;

        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${jwtToken}`,
          },
        };
        const UploadResponse = await axios.post(url, formData, config);

        // Check the response status and show appropriate message
        if (UploadResponse.data.isSuccess == true) {
          onSuccess(file);
          const fileName = file.name;
          setSelectedFile(file);
          message.success(`${fileName} Uploaded Successfully`);
          updatedFile.status = "done";
          setFileList([updatedFile]);
          GetTableData();
          setUploadSpinLoader(false);
          setManualLoadingFileName("");
        } else {
          onError(file);
          message.error(UploadResponse.data.message);
          updatedFile.status = "error";
          setFileList([updatedFile]);
          setUploadSpinLoader(false);
          setManualLoadingFileName("");
        }

        // Reset the upload loading flag and fetch data into the Grid
        setAdjUploadFlag(false);
        // fetchData();
      } catch (error) {
        // Show an error message and reset the upload flag
        message.error("Please try again");
        setAdjUploadFlag(false);
        // fetchData();
      }
    };

    // Start reading the file as an ArrayBuffer
    reader.readAsArrayBuffer(file);
  };
  const itemRender = (originNode, file) => {
    let statusColor;
    if (file.status === "done") {
      statusColor = "green";
    } else if (file.status === "error") {
      statusColor = "#f55451";
    }
    let fileExists = false;
    if (fileList.length > 0) {
      fileExists = true;
    }
    return (
      <>
        <div
          style={{
            color: statusColor,
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#f2f8fc",
            marginTop: "2px",
            borderRadius: "4px",
          }}
        >
          {fileExists ? fileList[0].file.name : null}
          <DeleteOutlined onClick={() => setFileList([])} />
        </div>
      </>
    );
  };

  const handleDownloadNewHireReHireCSV = () => {
    setSpin(true);
    let DataCopy = data;
    let CSVStructuredData = [];
    CSVStructuredData.length = 0;
    let DataCopySize = DataCopy.length;
    // Function to sanitize cell values
    const sanitizeCell = (value) => {
      if (typeof value === 'string' && /^[=+\-@]/.test(value)) {
          return `'${value}`; // Prefix with an apostrophe
      }
      return value; // Return value as-is
  };
    CSVStructuredData.push([
      "Company ID",
      "Employee ID",
      "Employee Type",
      "First Name",
      "Middle Name",
      "Last Name",
      "Preferred Name",
      "IC Company Name",
      "SSN",
      "Federal ID Number",
      "Birth Date",
      "Clock ID",
      "Sex",
      "Ethnic Origin",
      "Address 1",
      "Address 2",
      "PO Box Number",
      "City",
      "State / Province",
      "Zip / Postal Code",
      "Country",
      "Telephone",
      "Cell Phone",
      "Work Phone",
      "Work Phone Ext",
      "Full/Part Time",
      "Eligible for Retirement Plan",
      "Organization Unit",
      "Business Location Name",
      "Position",
      "EEO Job Category",
      "Work State",
      "Officer Type",
      "Class Code",
      "Class Code Suffix",
      "Waive Code",
      "Employee Status",
      "Reason",
      "Reason Description",
      "Status Date",
      "Keep DD Active",
      "Deactivate Date",
      "Benefits Termination Reason",
      "Supervisor",
      "Pay Rate 1",
      "Pay Rate Amount 1",
      "Pay Rate 1 Org Unit",
      "Pay Rate #",
      "Pay Rate Amount #",
      "Pay Rate # Org Unit",
      "Pay Rate Default",
      "Pay Frequency",
      "Benefits Pay Frequency",
      "Standard Pay Hours",
      "Standard OT Hours",
      "Standard Hours #",
      "Standard OT Hours #",
      "Overtime Exempt",
      "Federal Tax Residency",
      "Federal Taxability Status",
      "Federal Filing Status",
      "Federal Allowances",
      "Multiple Jobs",
      "Dependents Amount",
      "Deductions Amount",
      "Other Income",
      "Federal Additional Tax Amount",
      "Federal Additional Tax Percentage",
      "Federal Override Tax Amount",
      "Federal Override Tax Percentage",
      "EE Sequence",
      "State Income Tax",
      "State Tax Residency",
      "State Percent Worked",
      "State Taxability Status",
      "State Unemployment",
      "Worksite Code",
      "State Disability",
      "State Filing Status",
      "State Allowance Name 1",
      "State Allowance Number 1",
      "State Allowance Amount 1",
      "State Allowance Name 2",
      "State Allowance Number 2",
      "State Allowance Amount 2",
      "State Allowance Name 3",
      "State Allowance Number 3",
      "State Allowance Amount 3",
      "State Additional Tax Amount",
      "State Additional Tax Percentage",
      "State Override Tax Amount",
      "State Override Tax Percentage",
      "Reduced Withholding Amount",
      "State Withholding %",
      "Dependent Health Insurance Benefits Indicator",
      "Date Dependent Health Ins Benefits are Available",
      "Employee Health Insurance Benefits Indicator",
      "Date Employee Health Ins Benefits are Available",
      "County",
      "Family Owned Business Owner Indicator",
      "Seasonal Indicator",
      "SOC",
      "SUI County",
      "State Jurisdiction 1",
      "Local Regulation Name 1",
      "Local Tax Residency 1",
      "PA Live/Work Status 1",
      "Local Taxability Status 1",
      "Local Filing Status 1",
      "Local Allowance Name 1",
      "Local Allowance Number 1",
      "% of Earnings Taxed 1",
      "Ohio Local Residence Tax Rate 1",
      "Local Additional Tax Amount 1",
      "Local Additional Tax Percent 1",
      "Local Override Tax Amount 1",
      "Local Override Tax Percent 1",
      "Employee Waiver Indicator 1",
      "State Jurisdiction 2",
      "Local Regulation Name 2",
      "Local Tax Residency 2",
      "PA Live/Work Status 2",
      "Local Taxability Status 2",
      "Local Filing Status 2",
      "Local Allowance Name 2",
      "Local Allowance Number 2",
      "% of Earnings Taxed 2",
      "Ohio Local Residence Tax Rate 2",
      "Local Additional Tax Amount 2",
      "Local Additional Tax Percent 2",
      "Local Override Tax Amount 2",
      "Local Override Tax Percent 2",
      "Employee Waiver Indicator 2",
      "State Jurisdiction 3",
      "Local Regulation Name 3",
      "Local Tax Residency 3",
      "PA Live/Work Status 3",
      "Local Taxability Status 3",
      "Local Filing Status 3",
      "Local Allowance Name 3",
      "Local Allowance Number 3",
      "% of Earnings Taxed 3",
      "Ohio Local Residence Tax Rate 3",
      "Local Additional Tax Amount 3",
      "Local Additional Tax Percent 3",
      "Local Override Tax Amount 3",
      "Local Override Tax Percent 3",
      "Employee Waiver Indicator 3",
      "Job Number",
      "Labor Assignment",
      "Home Email",
      "Work Email",
      "Hired Date",
      "Benefits Eligibility Indicator",
      "Benefits Override Date",
      "Benefits Custom Field Name 1",
      "Benefits Custom Field Value 1",
      "Benefits Custom Field Name 2",
      "Benefits Custom Field Value 2",
      "Benefits Custom Field Name 3",
      "Benefits Custom Field Value 3",
      "Benefits Custom Field Name 4",
      "Benefits Custom Field Value 4",
      "Benefits Custom Field Name 5",
      "Benefits Custom Field Value 5",
      "Benefits Custom Field Name 6",
      "Benefits Custom Field Value 6",
      "Benefits Custom Field Name 7",
      "Benefits Custom Field Value 7",
      "Insurance Standard Hours",
      "Insurance Standard Hours Same as Standard Hours",
      "Insurance Annual Salary Override",
      "Insurance Annual Salary",
    ]);

    for (let i = 0; i < DataCopySize; i++) {
      CSVStructuredData.push([
        sanitizeCell(DataCopy[i]["companyID"]),
        sanitizeCell(DataCopy[i]["employeeID"]),
        sanitizeCell(DataCopy[i]["employeeType"]),
        sanitizeCell(DataCopy[i]["firstName"]),
        sanitizeCell(DataCopy[i]["middleName"]),
        sanitizeCell(DataCopy[i]["lastName"]),
        sanitizeCell(DataCopy[i]["preferredName"]),
        sanitizeCell(DataCopy[i]["icCompanyName"]),
        sanitizeCell(DataCopy[i]["ssn"]),
        sanitizeCell(DataCopy[i]["federalIDNumber"]),
        sanitizeCell(DataCopy[i]["birthDate"]),
        sanitizeCell(DataCopy[i]["clockID"]),
        sanitizeCell(DataCopy[i]["sex"]),
        sanitizeCell(DataCopy[i]["ethnicOrigin"]),
        sanitizeCell(DataCopy[i]["address1"]),
        sanitizeCell(DataCopy[i]["address2"]),
        sanitizeCell(DataCopy[i]["poBoxNumber"]),
        sanitizeCell(DataCopy[i]["city"]),
        sanitizeCell(DataCopy[i]["stateProvince"]),
        sanitizeCell(DataCopy[i]["zipPostalCode"]),
        sanitizeCell(DataCopy[i]["country"]),
        sanitizeCell(DataCopy[i]["telephone"]),
        sanitizeCell(DataCopy[i]["cellPhone"]),
        sanitizeCell(DataCopy[i]["workPhone"]),
        sanitizeCell(DataCopy[i]["workPhoneExt"]),
        sanitizeCell(DataCopy[i]["fullPartTime"]),
        sanitizeCell(DataCopy[i]["eligibleForRetirementPlan"]),
        sanitizeCell(DataCopy[i]["organizationUnit"]),
        sanitizeCell(DataCopy[i]["businessLocationName"]),
        sanitizeCell(DataCopy[i]["position"]),
        sanitizeCell(DataCopy[i]["eeoJobCategory"]),
        sanitizeCell(DataCopy[i]["workState"]),
        sanitizeCell(DataCopy[i]["officerType"]),
        sanitizeCell(DataCopy[i]["classCode"]),
        sanitizeCell(DataCopy[i]["classCodeSuffix"]),
        sanitizeCell(DataCopy[i]["waiveCode"]),
        sanitizeCell(DataCopy[i]["employeeStatus"]),
        sanitizeCell(DataCopy[i]["reason"]),
        sanitizeCell(DataCopy[i]["reasonDescription"]),
        sanitizeCell(DataCopy[i]["statusDate"]),
        sanitizeCell(DataCopy[i]["keepDDActive"]),
        sanitizeCell(DataCopy[i]["deactiveDate"]),
        sanitizeCell(DataCopy[i]["benefitsTerminationReason"]),
        sanitizeCell(DataCopy[i]["supervisor"]),
        sanitizeCell(DataCopy[i]["payRate1"],),
        sanitizeCell(DataCopy[i]["payRateAmount1"]),
        sanitizeCell(DataCopy[i]["payRate1OrgUnit"]),
        sanitizeCell(DataCopy[i]["payRate"]),
        sanitizeCell(DataCopy[i]["payRateAmount"]),
        sanitizeCell(DataCopy[i]["payRateOrgUnit"]),
        sanitizeCell(DataCopy[i]["payRateDefault"]),
        sanitizeCell(DataCopy[i]["payFrequency"]),
        sanitizeCell(DataCopy[i]["benefitsPayFrequency"]),
        sanitizeCell(DataCopy[i]["standardPayHours"]),
        sanitizeCell(DataCopy[i]["standardOTHours"]),
        sanitizeCell(DataCopy[i]["standardHours"]),
        sanitizeCell(DataCopy[i]["standardOTHoursNum"]),
        sanitizeCell(DataCopy[i]["overtimeExempt"]),
        sanitizeCell(DataCopy[i]["federalTaxResidency"]),
        sanitizeCell(DataCopy[i]["federalTaxabilityStatus"]),
        sanitizeCell(DataCopy[i]["federalFilingStatus"]),
        sanitizeCell(DataCopy[i]["federalAllowances"]),
        sanitizeCell(DataCopy[i]["multipleJobs"]),
        sanitizeCell(DataCopy[i]["dependentsAmount"]),
        sanitizeCell(DataCopy[i]["deductionsAmount"]),
        sanitizeCell(DataCopy[i]["otherIncome"]),
        sanitizeCell(DataCopy[i]["federalAdditionalTaxAmount"]),
        sanitizeCell(DataCopy[i]["federalAdditionalTaxPercentage"]),
        sanitizeCell(DataCopy[i]["federalOverrideTaxAmount"]),
        sanitizeCell(DataCopy[i]["federalOverrideTaxPercentage"]),
        sanitizeCell(DataCopy[i]["eeSequence"]),
        sanitizeCell(DataCopy[i]["stateIncomeTax"]),
        sanitizeCell(DataCopy[i]["stateTaxResidency"]),
        sanitizeCell(DataCopy[i]["statePercentWorked"]),
        sanitizeCell(DataCopy[i]["statePercentWorked"]),
        sanitizeCell(DataCopy[i]["statePercentWorked"]),
        sanitizeCell(DataCopy[i]["stateTaxabilityStatus"]),
        sanitizeCell(DataCopy[i]["stateUnemployment"]),
        sanitizeCell(DataCopy[i]["worksiteCode"]),
        sanitizeCell(DataCopy[i]["stateDisability"]),
        sanitizeCell(DataCopy[i]["stateFilingStatus"]),
        sanitizeCell(DataCopy[i]["stateAllowanceName1"]),
        sanitizeCell(DataCopy[i]["stateAllowanceNumber1"]),
        sanitizeCell(DataCopy[i]["stateAllowanceAmount1"]),
        sanitizeCell(DataCopy[i]["stateAllowanceName2"]),
        sanitizeCell(DataCopy[i]["stateAllowanceNumber2"]),
        sanitizeCell(DataCopy[i]["stateAllowanceAmount2"]),
        sanitizeCell(DataCopy[i]["stateAllowanceName3"]),
        sanitizeCell(DataCopy[i]["stateAllowanceNumber3"]),
        sanitizeCell(DataCopy[i]["stateAllowanceAmount3"]),
        sanitizeCell(DataCopy[i]["stateAdditionalTaxAmount"]),
        sanitizeCell(DataCopy[i]["stateAdditionalTaxPercentage"]),
        sanitizeCell(DataCopy[i]["stateOverrideTaxAmount"]),
        sanitizeCell(DataCopy[i]["stateOverrideTaxPercentage"]),
        sanitizeCell(DataCopy[i]["reducedWithholdingAmount"]),
        sanitizeCell(DataCopy[i]["stateWithholdingPercentage"]),
        sanitizeCell(DataCopy[i]["dependentHealthInsuranceBenefitsIndicator"]),
        sanitizeCell(DataCopy[i]["dateDependentHealthInsBenefitsAvailable"]),
        sanitizeCell(DataCopy[i]["employeeHealthInsuranceBenefitsIndicator"]),
        sanitizeCell(DataCopy[i]["dateEmployeeHealthInsBenefitsAvailable"]),
        sanitizeCell(DataCopy[i]["county"]),
        sanitizeCell(DataCopy[i]["familyOwnedBusinessOwnerIndicator"]),
        sanitizeCell(DataCopy[i]["seasonalIndicator"]),
        sanitizeCell(DataCopy[i]["SOC"]),
        sanitizeCell(DataCopy[i]["SUI County"]),
        sanitizeCell(DataCopy[i]["stateJurisdiction1"]),
        sanitizeCell(DataCopy[i]["localRegulationName1"]),
        sanitizeCell(DataCopy[i]["localTaxResidency1"]),
        sanitizeCell(DataCopy[i]["PA Live/Work Status 1"]),
        sanitizeCell(DataCopy[i]["localTaxabilityStatus1"]),
        sanitizeCell(DataCopy[i]["localFilingStatus1"]),
        sanitizeCell(DataCopy[i]["localAllowanceName1"]),
        sanitizeCell(DataCopy[i]["localAllowanceNumber1"]),
        sanitizeCell(DataCopy[i]["% of Earnings Taxed 1"]),
        sanitizeCell(DataCopy[i]["Ohio Local Residence Tax Rate 1"]),
        sanitizeCell(DataCopy[i]["localAdditionalTaxAmount1"]),
        sanitizeCell(DataCopy[i]["localAdditionalTaxPercent 1"]),
        sanitizeCell(DataCopy[i]["localOverrideTaxAmount1"]),
        sanitizeCell(DataCopy[i]["localOverrideTaxPercent 1"]),
        sanitizeCell(DataCopy[i]["employeeWaiverIndicator1"]),
        sanitizeCell(DataCopy[i]["stateJurisdiction2"]),
        sanitizeCell(DataCopy[i]["localRegulationName2"]),
        sanitizeCell(DataCopy[i]["localTaxResidency2"]),
        sanitizeCell(DataCopy[i]["PA Live/Work Status 2"]),
        sanitizeCell(DataCopy[i]["localTaxabilityStatus2"]),
        sanitizeCell(DataCopy[i]["localFilingStatus2"]),
        sanitizeCell(DataCopy[i]["localAllowanceName2"]),
        sanitizeCell(DataCopy[i]["localAllowanceNumber2"]),
        sanitizeCell(DataCopy[i]["% of Earnings Taxed 2"]),
        sanitizeCell(DataCopy[i]["Ohio Local Residence Tax Rate 2"]),
        sanitizeCell(DataCopy[i]["localAdditionalTaxAmount2"]),
        sanitizeCell(DataCopy[i]["localAdditionalTaxPercent 2"]),
        sanitizeCell(DataCopy[i]["localOverrideTaxAmount2"]),
        sanitizeCell(DataCopy[i]["localOverrideTaxPercent 2"]),
        sanitizeCell(DataCopy[i]["employeeWaiverIndicator2"]),
        sanitizeCell(DataCopy[i]["stateJurisdiction3"]),
        sanitizeCell(DataCopy[i]["localRegulationName3"]),
        sanitizeCell(DataCopy[i]["localTaxResidency3"]),
        sanitizeCell(DataCopy[i]["PA Live/Work Status 3"]),
        sanitizeCell(DataCopy[i]["localTaxabilityStatus3"]),
        sanitizeCell(DataCopy[i]["localFilingStatus3"]),
        sanitizeCell(DataCopy[i]["localAllowanceName3"]),
        sanitizeCell(DataCopy[i]["localAllowanceNumber3"]),
        sanitizeCell(DataCopy[i]["% of Earnings Taxed 3"]),
        sanitizeCell(DataCopy[i]["Ohio Local Residence Tax Rate 3"]),
        sanitizeCell(DataCopy[i]["localAdditionalTaxAmount3"]),
        sanitizeCell(DataCopy[i]["localAdditionalTaxPercent 3"]),
        sanitizeCell(DataCopy[i]["localOverrideTaxAmount3"]),
        sanitizeCell(DataCopy[i]["localOverrideTaxPercent 3"]),
        sanitizeCell(DataCopy[i]["employeeWaiverIndicator3"]),
        sanitizeCell(DataCopy[i]["jobNumber"]),
        sanitizeCell(DataCopy[i]["laborAssignment"]),
        sanitizeCell(DataCopy[i]["homeEmail"]),
        sanitizeCell(DataCopy[i]["workEmail"]),
        sanitizeCell(DataCopy[i]["hiredDate"]),
        sanitizeCell(DataCopy[i]["benefitsEligibilityIndicator"]),
        sanitizeCell(DataCopy[i]["benefitsOverrideDate"]),
        sanitizeCell(DataCopy[i]["benefitsCustomFieldName1"]),
        sanitizeCell(DataCopy[i]["benefitsCustomFieldValue1"]),
        sanitizeCell(DataCopy[i]["benefitsCustomFieldName2"]),
        sanitizeCell(DataCopy[i]["benefitsCustomFieldValue2"]),
        sanitizeCell(DataCopy[i]["benefitsCustomFieldName3"]),
        sanitizeCell(DataCopy[i]["benefitsCustomFieldValue3"]),
        sanitizeCell(DataCopy[i]["benefitsCustomFieldName4"]),
        sanitizeCell(DataCopy[i]["benefitsCustomFieldValue4"]),
        sanitizeCell(DataCopy[i]["benefitsCustomFieldName5"]),
        sanitizeCell(DataCopy[i]["benefitsCustomFieldValue5"]),
        sanitizeCell(DataCopy[i]["benefitsCustomFieldName6"]),
        sanitizeCell(DataCopy[i]["benefitsCustomFieldValue6"]),
        sanitizeCell(DataCopy[i]["benefitsCustomFieldName7"]),
        sanitizeCell(DataCopy[i]["benefitsCustomFieldValue7"]),
        sanitizeCell(DataCopy[i]["insuranceStandardHours"]),
        sanitizeCell(DataCopy[i]["insuranceStandardHoursSame as Standard Hours"]),
        sanitizeCell(DataCopy[i]["insuranceAnnualSalaryOverride"]),
        sanitizeCell(DataCopy[i]["insuranceAnnualSalary"]),
      ]);
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    for (let i = 0; i < CSVStructuredData.length; i++) {
      worksheet.addRow(CSVStructuredData[i].map(sanitizeCell));
    }

    SuccessMessage("NewHire ReHire Csv file dwonloaded successfully");
    setSpin(false);
    return workbook.csv.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: "text/csv;charset=utf-8" });
      FileSaver.saveAs(blob, "NewHireReHire.csv");
    });
  };

  const AddNewRecord = async () => {
    // console.log(CurrentEditingKey);
    if (CurrentEditingKey === "") {
      let NewRecordArray = {};
      for (let index in columns) {
        if (columns[index].dataIndex == "employeeID") {
          NewRecordArray[columns[index].dataIndex] = "tempId";
        } else {
          NewRecordArray[columns[index].dataIndex] = "";
        }
      }
      setOldData([...data]);
      setData([NewRecordArray, ...data]);
      // console.log(NewRecordArray);
      form.setFieldsValue({ ...NewRecordArray });
      setNewRecordKey("tempId");
      setCurrentEditingKey("tempId");
    } else {
      InfoMessage("Please save/discard the record");
    }
  };

  return (
    <>
      <div>
        <div className="upload-elements">
          <div className="heading-newhire">New Hires/Re Hires</div>
       
        </div>
        <div className="addnew-row">
          <div>
          <Button
            className="row-button"
            onClick={() => AddNewRecord()}
            disabled={AddNewDisable}
          >
            Add New Row <PlusOutlined />
          </Button>
          <Input
            placeholder="Search with Employee Id\Company Id\First Name"
            className="input-searchroww"
            // style={{ borderColor: "#002766", color: "#3B52DF" }}
            onChange={(e) => SearchEmployee(e.target.value)}
            suffix={
              <SearchOutlined
                style={{ color: "#7185FF", justifyContent: "space-between" }}
              />
            }
          />
          </div>
             <div style={{ display: "flex", flexDirection: "row" }}>
            <Upload.Dragger
              accept=".xls,.xlsx"
              customRequest={UploadManualAdjustment}
              itemRender={itemRender}
              fileList={fileList}
              onRemove={() => setFileList([])}
              className="newhire-upload"
            >
              Manual Upload
              <UploadOutlined className="newhireupload-iconn" />
              {AdjUploadFlag ? (
                <Spin
                  indicator={
                    <div style={{ alignItems: "center" }}>
                      <LoadingOutlined />
                    </div>
                  }
                ></Spin>
              ) : (
                <></>
              )}
            </Upload.Dragger>
            <Button
              className="csv-buttonn"
              onClick={() => handleDownloadNewHireReHireCSV()}
            >
              Download .CSV <DownloadOutlined />
            </Button>
          </div>
          {spin ? <Spin size="medium" /> : null}
        </div>
        <div className="newhire-table">
          <Form form={form} component={false}>
            <Table
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              columns={mergedColumns}
              dataSource={data}
              pagination={false}
              scroll={{ x: "max-content", y: 360 }}
              loading={loading}
              bordered
            />
          </Form>
        </div>
      </div>
    </>
  );
};
export default NewHiresReHires;
